export default __webpack_public_path__ + "static/media/9.ab158ae6.jpg";